import { useState } from "react";
import { Modal } from "flowbite-react";
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";
import { useToastContext } from "@/common/components/ui/toast/toast.context";
import { removeAccessEmployee } from "@/common/services/employee.api";

type Props = {
  employeeId: string;
  employeeName?: string;
  onClose: () => void;
  onSuccess?: () => void;
};

export default function RemoveAceessEmployees({
  employeeId,
  employeeName,
  onClose,
  onSuccess,
}: Props) {
  const { showToast } = useToastContext();
  const [description, setDescription] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const notifySuccess = (text: string) => showToast({ text, type: "success" });
  const notifyError = (text: string) => showToast({ text, type: "error" });

  const handleSubmit = async () => {
    if (!description.trim()) {
      notifyError("Informe o motivo do cancelamento de acesso.");
      return;
    }

    try {
      setIsLoading(true);
      const response = await removeAccessEmployee(employeeId, description.trim());

      if (!response.ok) {
        notifyError(response.message || "Erro ao cancelar acesso.");
        return;
      }

      notifySuccess(
        `Acesso do colaborador ${employeeName || ""} cancelado com sucesso.`
      );
      onSuccess?.();
      onClose();
    } catch {
      notifyError("Erro ao cancelar acesso. Tente novamente.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      size={"2xl"}
      className="relative px-2 sm:px-0"
      show={true}
      onClose={onClose}
    >
      <Modal.Header className="text-black">
        <div className="flex min-w-0 items-center justify-start gap-3 text-black">
          <span>Cancelar acesso do colaborador</span>
        </div>
      </Modal.Header>
      <Modal.Body className="relative flex w-full flex-col gap-3 px-3 pb-4 pt-2 text-black sm:px-5">
        <label htmlFor="remove-access-description" className="font-medium">
          Motivo
        </label>
        <textarea
          id="remove-access-description"
          name="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="border rounded p-2 min-h-[120px]"
          placeholder="Descreva o motivo do cancelamento de acesso"
        />
      </Modal.Body>
      <Modal.Footer className="flex flex-col-reverse justify-end gap-2 sm:flex-row">
        <ButtonWithLoader
          className="button-with-loader mt-0 w-full sm:w-auto sm:min-w-[140px]"
          type="button"
          onClick={onClose}
        >
          Fechar
        </ButtonWithLoader>
        <ButtonWithLoader
          className="button-with-loader mt-0 w-full sm:w-auto sm:min-w-[140px]"
          isLoading={isLoading}
          type="button"
          onClick={handleSubmit}
        >
          Salvar
        </ButtonWithLoader>
      </Modal.Footer>
    </Modal>
  );
}
